import axios from 'axios'
import NProgress from 'nprogress'
import apiUrl from '@/services/apiConfig'

let axiosInstance = axios.create({
  baseURL: apiUrl,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('aid')}`,
  },
})

let axiosInstanceRefresh = axios.create({
  baseURL: apiUrl,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('refresh')}`,
  },
})

let isRefreshing = false
let refreshSubscribers = []

const forceLogout = () => {
  localStorage.removeItem('aid')
  localStorage.removeItem('refresh')
  localStorage.removeItem('user')
  localStorage.removeItem('appCompany')

  window.location = '/login'
}

const subscribeTokenRefresh = (callback) => {
  refreshSubscribers.push(callback)
}

const onRefreshed = (token) => {
  refreshSubscribers.forEach((callback) => callback(token))
  refreshSubscribers = []
}

axiosInstance.interceptors.request.use(
  function (config) {
    NProgress.start()
    const token = localStorage.getItem('aid')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  function (error) {
    NProgress.done()
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (response) => {
    NProgress.done()
    return response
  },
  async (error) => {
    NProgress.done()

    const originalRequest = error.config
    const status = error.response?.status
    const msg = error.response?.data?.msg

    // ==========================
    // JWT INVALID / RUSAK
    // ==========================
    if (status === 422 && msg === 'Not enough segments') {
      forceLogout()
      return Promise.reject(error)
    }

    // ==========================
    // 401 -> REFRESH TOKEN
    // ==========================
    if (status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve) => {
          subscribeTokenRefresh((token) => {
            originalRequest.headers['Authorization'] = `Bearer ${token}`

            resolve(axiosInstance(originalRequest))
          })
        })
      }

      originalRequest._retry = true
      isRefreshing = true

      try {
        const refreshToken = localStorage.getItem('refresh')

        const response = await axiosInstanceRefresh.post(
          '/user/refresh',
          null,
          {
            headers: {
              Authorization: `Bearer ${refreshToken}`,
            },
          }
        )

        const newAccessToken = response.data.data.access_token

        localStorage.setItem('aid', newAccessToken)

        onRefreshed(newAccessToken)

        axiosInstance.defaults.headers[
          'Authorization'
        ] = `Bearer ${newAccessToken}`

        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`

        return axiosInstance(originalRequest)
      } catch (refreshError) {
        forceLogout()
        return Promise.reject(refreshError)
      } finally {
        isRefreshing = false
      }
    }

    return Promise.reject(error)
  }
)

export default axiosInstance
